import { render, staticRenderFns } from "./PreviewLink.vue?vue&type=template&id=ac586970&"
import script from "./PreviewLink.vue?vue&type=script&lang=js&"
export * from "./PreviewLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports